import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectUserIsIdentified } from 'core/selectors/user';
import { postInstoreCardLink } from 'core/actions/member';
import { AddCardButton, InstoreLoginLink } from 'core/modules/Instore2/partials';
import LinkedCards from 'core/modules/Instore2/components/MePage/MeInstoreOffer/partials/LinkedCards';
import { HSR_PAGE_INSTORE } from 'core/modules/Instore2/utils/constants';

function InstoreOfferButtons({ instoreOffer, onClickCallback }) {
  const dispatch = useDispatch();
  const isUserIdentified = useSelector(selectUserIsIdentified);

  const {
    hasEligibleCards, hasLinkedCards, offerId, rclonMerchantName,
  } = instoreOffer;

  const linkOffer = () => {
    onClickCallback?.();

    dispatch(postInstoreCardLink(
      offerId,
      {},
      {},
      { initiator: HSR_PAGE_INSTORE, offer: instoreOffer },
    ));

    return true;
  };

  if (!isUserIdentified) {
    return (
      <InstoreLoginLink className="mn_button mn_secondaryButton">
        Sign in to link
      </InstoreLoginLink>
    );
  }

  if (hasLinkedCards) {
    return (<LinkedCards offer={instoreOffer} />);
  }

  if (!hasEligibleCards) {
    return (
      <AddCardButton
        className="mn_button mn_secondaryButton"
        offerId={offerId}
        merchantName={rclonMerchantName}
      />
    );
  }

  return (
    <button
      className="mn_button mn_secondaryButton mn_linkOffer"
      onClick={linkOffer}
    >
      Link offer
    </button>
  );
}

export default InstoreOfferButtons;
